// Tracks scroll position & speed delta
export class Scroll {
  static currentPosition: number = window.pageYOffset
  static delta = 0
  private static eventListener = setInterval(Scroll.calcDelta.bind(Scroll), 100)

  private static calcDelta(): void {
    Scroll.delta = Math.abs(Scroll.currentPosition - window.pageYOffset)
    this.currentPosition = window.pageYOffset
  }
}
